<template lang="pug">
    tbody.purchased-item-preview
        tr.purchased-item-table-row
            td.min(valign="top" rowspan="2")
                item-media-preview(:item="item")
            td.info(valign="top")
                .name(v-line-clamp="1")
                    span {{ item.name }}
                    span.purchase-info(v-if="item.purchase")
                        | {{ $t('purchased at {date}', { date: formatDate(item.purchase.created_at) }) }}
                small.nr {{ item.product_nr }}
                template(v-if="item.sku")
                    span &nbsp;/&nbsp;
                    small {{ item.sku }}
            td.min(valign="top" align="right")
                //- nobr.price {{ product.price.value | moneyFormat(currencyCode) }}
                .missing-price(v-if="item.price == undefined")
                    nobr.dimmed {{ $t('Missing Price') }}
                .sale-price(v-else-if="item.sale_price")
                    .nobr
                        s.strike-through {{ item.price | moneyFormat(currencyCode) }}
                        //- span.percentage {{ (item.price - item.sale_price) / item.price * 100 | round(2) }}%
                    nobr.red {{ item.sale_price | moneyFormat(currencyCode) }}
                nobr(v-else) {{ item.price | moneyFormat(currencyCode) }}
        tr.purchased-item-table-row
            td.info(valign="bottom" colspan="2")
                .property-container
                    //- .property(v-for="property in item.selectedProperties")
                    //-     property-pivot-values(
                    //-         :key="property.id"
                    //-         :property="property"
                    //-         :value-options="[property.value]"
                    //-     )
                    property-value(
                        v-for="property in item.selectedProperties"
                        :key="property.id"
                        :property="property"
                    )
                transition(name="slide-decent-vertical" mode="out-in")
                    .stocks(v-if="item.article && item.article.stocks && showStocks" key="stocks")
                        transition(name="slide-decent-vertical" mode="out-in")
                            table.default-table(v-if="item.article.stocks.length")
                                thead
                                    tr
                                        th.min.icon
                                        th.col-left.name
                                            nobr {{ $t('Stock') }}
                                        th.col-left.sellable
                                            //- nobr {{ $t('Sellable From/To') }}
                                        th.col-center.qty
                                            nobr {{ $t('Available') }}
                                        th.min.actions
                                tbody
                                    tr.spacer
                                        td(colspan="5")
                                    tr.stock(v-for="stock in item.article.stocks")
                                        td.min.icon
                                            span.icon.disabled(v-if="stock && stock.status !== 'enabled'")
                                                el-tooltip(effect="dark" :content="$t('Disabled in the stock settings')" placement="top")
                                                    i.el-icon-warning
                                            span.icon.sold-out(v-else-if="stock.pivot.qty <= 0")
                                                el-tooltip(effect="dark" :content="$t('Sold out')" placement="top")
                                                    i.el-icon-warning-outline
                                            span.icon.enabled(v-else)
                                                i.el-icon-success
                                        td.col-left.name
                                            nobr {{ stock.name }}
                                        td.col-left.sellable
                                            nobr.danger
                                                .from(v-if="stock.pivot.sellable_from") {{ $t('From') }}: {{ stock.pivot.sellable_from | timestamp2date($t('yyyy-MM-dd')) }}
                                                .to(v-if="stock.pivot.sellable_to") {{ $t('To') }}: {{ stock.pivot.sellable_to | timestamp2date($t('yyyy-MM-dd')) }}
                                        td.min.col-center.qty
                                            nobr {{ stock.pivot.qty }}
                                        td.min.col-right.actions
                                            nobr(v-loading="stock.loading")
                                                el-button(
                                                    v-if="stock && stock.pivot.qty > 0 && ! (activePointOfSale.stocks || []).find(el => el.id === stock.id)"
                                                    type="text"
                                                    :disabled="stock.loading"
                                                    @click.stop="requestArticle(stock)"
                                                ) {{ $t('request 1x') }}
                                                el-button(
                                                    v-else-if="stock && (activePointOfSale.stocks || []).find(el => el.id === stock.id)"
                                                    type="text"
                                                    :disabled="stock.loading"
                                                    @click.stop="takeBackArticle(stock, item.article, item.sale_price || item.price)"
                                                ) {{ $t('take back 1x') }}
                                    tr.spacer
                                        td(colspan="5")
                            .alert.warning(v-else key="alert")
                                p {{ $t('There is no stock for this article') }}
                transition(name="slide-decent-vertical" mode="out-in")
                    //- .alert.danger(
                    //-     v-if="!item.article || !item.article.product"
                    //-     key="alert"
                    //- )
                    //-     p {{ $t('Could not find the related article') }}
                    .actions(v-if="item.article && item.article.product && item.article.product.manage_stock" key="actions")
                        el-button.stocks(
                            plain
                            type="primary"
                            size="mini"
                            icon="el-icon-fa-dolly fas"
                            @click="showStocks = !showStocks"
                        )
                            template(v-if="showStocks") {{ $t('Hide stocks') }}
                            template(v-else) {{ $t('Show stocks') }}
        tr.purchased-item-table-row
            td.divider(colspan="5")
                hr
</template>

<i18n>
{
    "en": {
        "purchased at {date}": "purchased at {date}"
    },
    "de": {
        "purchased at {date}": "gekauft am {date}",
        "Show stocks": "Bestände anzeigen",
        "Hide stocks": "Bestände verbergen",
        "Could not find the related article": "Artikel konnte nicht gefunden werden",
        "There is no stock for this article": "Für diesen Artikel gibt es keinen Bestand",
        "request 1x": "1x anfordern",
        "take back 1x": "1x zurücknehmen",
        "Available": "Verfügbar",
        "Sellable From/To": "Verkaufbar ab/bis",
        "From": "Ab",
        "Disabled in the stock settings": "In den Lagereinstellungen deaktiviert",
        "Sold out": "Ausverkauft",
        "To": "Bis",
        "Stock": "Lager",
        "Article not found": "Artikel konnte nicht gefunden werden",
        "Article requested successfully!": "Artikel wurde erfolgreich angefordert!",
        "Article has been taken back successfully!": "Der Artikel wurde erfolgreich zurückgenommen!",
        "Missing Price": "Preis fehlt",
        "Article could not be requested.": "Artikel konnte nicht angefordert werden."
    }
}
</i18n>

<script>

import _ from 'lodash';
import uniqid from 'uniqid';
import { useSetupStore, usePosSetupStore, usePosCartStore } from '@/stores';

import { moneyFormat, timestamp2date } from '@/filters';

import StockApi from '@/extensions/shop/pointOfSale/store/api/stock';
import ItemMediaPreview from './ItemMediaPreview';
// import PropertyPivotValues from '@/extensions/shop/components/Products/PropertyPivotValues'
import PropertyValue from '@/extensions/shop/views/Purchase/Form/Partials/PropertyValue'

export default {
    name: 'PurchasedItemPreview',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        showStocks: false,
    }),
    components: {
        ItemMediaPreview,
        // PropertyPivotValues,
        PropertyValue,
    },
    filters: {
        moneyFormat,
        timestamp2date
    },
    computed: {
        activeCms() {
            return useSetupStore().activeCms
        },
        posSetupStore() {
            return usePosSetupStore();
        },
        posCartStore() {
            return usePosCartStore();
        },
        activePointOfSale() {
            return this.posSetupStore.activePointOfSale;
        },
        currency() {
            return this.posSetupStore.currency;
        },
        currencyCode() {
            return _.get(this.item, 'purchase.currency')
                || _.get(this.curency, 'iso4217')
        }
        // price() {
        //     let price = _.get(this.product.price, 'value')
        //     if (this.selectedArticle) price = _.get(this.selectedArticle.price, 'value') || price
        //     return price + this.surcharge
        // },
        // salePrice() {
        //     let price = _.get(this.product.salePrice, 'value')
        //     if (this.selectedArticle) price = _.get(this.selectedArticle.salePrice, 'value') || price
        //     return price + this.surcharge
        // },
    },
    methods: {
        formatDate(timestamp) {
            return timestamp2date(timestamp, this.$t('yyyy-MM-dd') + ', HH:mm')
        },
        requestArticle(stock) {
            this.$set(stock, 'loading', true)

            const handleError = () => {
                this.$notify.error({
                    title: this.$t('An error occurred!'),
                    message: this.$t('Article could not be requested.'),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000,
                })
            }

            this.posCartStore.requestArticles({
                shop: this.activeCms.shop,
                items: [{
                    id: uniqid('new:'),
                    qty: 1,
                    stocks: [{ id: stock.id }],
                    article: { id: this.item.article.id },
                    propertyValueOptions: this.item.selectedProperties.map(prop => prop.value)
                }],
            })
                .then(purchase => {
                    if (purchase.errors && purchase.errors.length) {
                        handleError()
                    } else {
                        this.$notify.success({
                            title: this.$t('Article requested successfully!'),
                            iconClass: 'fas el-icon-fa-check',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }
                })
                .catch(err => {
                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err)
                    handleError()
                })
                .finally(() => {
                    this.$delete(stock, 'loading')
                })
        },
        async takeBackArticle(stock, article, price) {
            this.$set(stock, 'loading', true)

            const payload = {
                uniqid: uniqid(),
                stock: { id: stock.id },
                action: 'increase',
                pointOfSale: this.activePointOfSale,
                skus: [ article.sku ]
            }

            let error
            await StockApi.updateStock(payload)
                .catch(err => {
                    const { networkError, graphQLErrors } = err;
                    const code = _.get(graphQLErrors, '0.code');
                    error = true;

                    if (code === 404) {
                        this.$notify.error({
                            title: this.$t('Article not found'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    } else {
                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }

                    console.error(err)
                })

            this.$delete(stock, 'loading')

            if (! error) {
                this.$set(stock.pivot, 'qty', stock.pivot.qty + 1)

                // // create coupon?
                // this.$emit('create-coupon', price)
                this.$emit('ask-for-refund', { article, stock, price })

                this.$notify.success({
                    title: this.$t('Article has been taken back successfully!'),
                    iconClass: 'fas el-icon-fa-check',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000,
                })
            }
        },
        // getSelectedValueOption(property) {
        //     const selectedProperty = this.selectedProperties.find(el => el.property.id === property.id)
        //     if (selectedProperty) return selectedProperty.valueOption
        //     else return null
        // },
    },
}
</script>

<style lang="sass" scoped>
.purchased-item-preview
    .name, .price
        font-weight: bold
    .purchase-info
        font-weight: normal
        &:before
            content: ' - '
    .nr
        font-size: 0.8em
    .actions
        margin-top: 0.6rem
    .alert
        margin: 0
        margin-top: 0.6rem
    .media,
    .placeholder
        position: sticky
        top: 0
    .stocks table.default-table
        width: 400px
        th
            padding: 0.6rem 1rem
        td
            padding: 0 1rem
        .min.icon
            padding-left: 8px
            padding-right: 0
        .name
            padding-left: 8px

        .icon
            i
                font-size: 1.2rem
            &.sold-out
                color: $--color-warning
            &.enabled
                color: $--color-success
            &.disabled
                color: $--color-danger

        .from, .to
            display: inline-block
        .from + .to
            margin-left: 1rem
        .actions::v-deep
            .el-loading-mask
                background: rgba(250, 250, 250, 0.8)
                pointer-events: none
                svg
                    width: 24px
                    circle
                        stroke-width: 4px

    .nobr
        white-space: nowrap

    .danger
        color: $--color-danger

    .sale-price
        text-align: right
        s
            display: inline-block
            // font-size: 0.6em
            // font-weight: bold
            text-decoration: none
            color: rgba(0,0,0,0.5)
        .red
            color: $--color-danger
        .strike-through
            position: relative
            &:before
                position: absolute
                content: ""
                left: -3px
                top: 50%
                right: -3px
                border-top: 1px solid rgba(0,0,0,0.5)
                // border-color: $--color-info
                transform: rotate(-5deg)

@keyframes spin
    0%
        transform: rotate(0deg)
    100%
        transform: rotate(360deg)

.spinner
    width: 20px
    height: 20px
    display: inline-block
    margin-right: 1rem
    top: 0.4rem
    position: relative

.el-button--text
    padding: 0

</style>
